import { Injectable } from "@angular/core"
import { HttpClient } from "@angular/common/http"
import { environment } from "../../../../environments/environment"
import { IIntegrationPaginateRequest } from "src/app/shared/interfaces/integration"
import { toHttpParams } from "../../../core/helpers/http-params-extensions"

@Injectable({
  providedIn: "root",
})
export class IntegrationService {
  private get_integrations_paginate: string
  private get_integrations: string

  constructor(private httpClient: HttpClient) {
    this.get_integrations_paginate =
      environment.endPointGoogleIntegration.url +
      environment.endPointGoogleIntegration.routes.get_integrations_paginate
    this.get_integrations =
      environment.endPointGoogleIntegration.url +
      environment.endPointGoogleIntegration.routes.get_integrations
  }

  getPaginate(integrationPaginateRequest: IIntegrationPaginateRequest) {
    let params = toHttpParams(integrationPaginateRequest)

    return this.httpClient.get(this.get_integrations_paginate, { params })
  }

  getIntegrationById(integrationId: string) {
    return this.httpClient.get(
      this.get_integrations.replace("{integrationId}", integrationId)
    )
  }
}
